export const sxStyle = {
  cityInputButtonContainer: {
    width: '100%',
    m: { xs: '0px auto', sm: 0 },
  },
  paxLockScreen: {
    position: 'fixed',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    zIndex: 100,
  },
};
